export const EventTypes = {
    SHOW_CREATE_NEW_ADDRESS: "DeliveryAddress.ShowCreateNew",
    TEXTS_LOADED: "DeliveryAddress.TextsLoaded",
    REMOVE_SELECTED_ADDRESS: "DeliveryAddress.RemoveSelectedAddress",
    SHOW_CURRENT_ADDRESS: "DeliveryAddress.ShowCurrentAddress",
    CHANGE_TELEPORT_TARGET: "DeliveryAddress.onChangeTeleportTarget",
    UNMOUNT_DELIVERY_ADDRESS_APP:"DeliveryAddress.UnmountApp"
};